import React from 'react';

import {formatDate,secondsToTime} from '../../helpers/uiFunctions/uiHelpers';

class MonitorHistory extends React.Component {
    render() {
        const toggleHistory = this.props.toggleHistory;
        const monitor = this.props.monitor;
        
        return(
            <div className="history">
                <i className="fas fa-times icon" onClick={toggleHistory}></i>
                <ul>
                    {monitor.logs.map((event, index) => 
                        <div key={index}>
                            <p><strong>Date-Time:</strong> {formatDate(event.datetime*1000)}</p>
                            <p><strong>Status Update:</strong> {event.reason.detail} ( {event.reason.code} )</p>
                            <p><strong>Status Duration:</strong> {secondsToTime(event.duration)}</p>
                        </div>
                    )}
                </ul>
            </div>
        )
    }
}
export default MonitorHistory;


// WEBPACK FOOTER //
// ./src/component_uptime/components/MonitorHistory.js